import {nioJsBridge} from "@nio-wad/universal-bridge-h5";
import {BRAND_MODULE_ID} from "@/config/constant";
import util from './utils';

export const BrandEnum = {
  nio:'nio',
  alps:'alps',
  fy:'fy'
}

export const getURLParams = () => {
  const url = location.href;
  const queryStr = url.split('?')[1];
  if (!queryStr) return {};
  const queryArr = queryStr.split('&');
  const paramsObj = {};
  for (let i = 0; i < queryArr.length; i++) {
    const item = queryArr[i].split('=');
    paramsObj[item[0]] = item[1];
  }
  return paramsObj;
};


export const isNio = () => {
  if (util.isInWebview() ) {
    console.log('isNio ==>');
    return nioJsBridge.currentInNioCNApp();
  } else {
    console.log('isNio web==>');
    const query = getURLParams();
    return query.brand !== 'alps' && query.brand !== 'fy';
  }
};

export const isAlps = () => {
  if (util.isInWebview()) {
    console.log('isAlps ==>');
    return nioJsBridge.currentInAlpsCNApp();
  } else {
    console.log('isAlps web==>');
    const query = getURLParams();
    let isAlpsFromParam = query.brand === 'alps';
    // 如果是生产环境，通过module_id判断
    if (process.env.NODE_ENV === 'production') {
      isAlpsFromParam = location.href.includes(`module_${BRAND_MODULE_ID.alps}`);
    }
    return isAlpsFromParam;
  }
};

export const isFyCN = () => {
  if (util.isInWebview()) {
    return nioJsBridge.currentInFireflyCNApp();
  } else {
    const query = getURLParams();
    let isfyFromParam = query.brand === 'fy';
    // 如果是生产环境，通过module_id判断
    if (process.env.NODE_ENV === 'production') {
      isfyFromParam = location.href.includes(`module_${BRAND_MODULE_ID.fy}`);
    }
    console.log('isfyFromParam==>',isfyFromParam);
    return isfyFromParam;
  }
};

export const currentBrand =() => {
  if (isAlps()) {
    return BrandEnum.alps
  } else if (isFyCN()) {
    return BrandEnum.fy;
  }
  return BrandEnum.nio
}